if (!customElements.get('runzie-bundle')) {
  customElements.define('runzie-bundle', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.required = Number(this.dataset.required);
      this.items = this.items || [];
      this.busy = false;
      this.key = `runzie-bundle:${this.dataset.source}:${this.dataset.parent}:${this.required}`;
      if (!this.querySelector('[data-bundle-form]')) return;
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.key));
        if (Array.isArray(saved) && saved.length <= this.required) this.items = saved.filter(x => x && /^\d+$/.test(x.id) && ['title','variant','sku','image'].every(k => typeof x[k] === 'string'));
      } catch (_) { /* Storage may be disabled. */ }
      const options = { signal: this.abort.signal };
      this.addEventListener('click', e => this.click(e), options);
      this.addEventListener('change', () => this.render(), options);
      this.addEventListener('submit', e => { if (e.target.matches('[data-bundle-form]')) this.submit(e); }, options);
      this.addEventListener('keydown', e => {
        if (!this.classList.contains('is-open')) return;
        if (e.key === 'Escape') this.open(false);
        if (e.key === 'Tab') {
          const nodes = [...this.querySelector('.rb-panel').querySelectorAll('button:not(:disabled),a[href],input:not([type=hidden])')].filter(n => !n.hidden && n.getClientRects().length);
          const first = nodes[0], last = nodes[nodes.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last?.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus(); }
        }
      }, options);
      this.render();
    }
    disconnectedCallback() { this.abort?.abort(); this.pageAbort?.abort(); }
    open(show) {
      this.classList.toggle('is-open', show);
      this.querySelector('.rb-backdrop').hidden = !show;
      this.querySelector('[data-toggle]').setAttribute('aria-expanded', String(show));
      (show ? this.querySelector('.rb-panel [data-close]') : this.querySelector('[data-toggle]')).focus();
    }
    click(e) {
      if (e.target.closest('[data-mobile-add]')) { this.submit(e); return; }
      const close = e.target.closest('[data-close]');
      if (close) { this.open(false); return; }
      if (e.target.closest('[data-toggle]')) { this.open(!this.classList.contains('is-open')); return; }
      const link = e.target.closest('.rb-pagination a');
      if (link) { e.preventDefault(); this.page(link.href); return; }
      if (this.busy) return;
      const remove = e.target.closest('[data-remove]');
      if (remove) { this.items.splice(Number(remove.dataset.remove), 1); this.render(); if (this.classList.contains('is-open')) this.querySelector('.rb-panel [data-close]').focus(); return; }
      const pick = e.target.closest('[data-pick]');
      if (!pick || this.items.length >= this.required) return;
      const option = pick.closest('[data-card]').querySelector('[data-variant]').selectedOptions[0];
      if (!option?.value || option.disabled) return;
      this.items.push({id: option.value, title: option.dataset.title, variant: option.dataset.variantTitle, sku: option.dataset.sku || '', image: option.dataset.image || ''});
      this.querySelector('[data-message]').textContent = '';
      this.querySelector('[data-view-cart]').hidden = true;
      this.render();
    }
    render() {
      const count = this.items.length, full = count === this.required;
      try { sessionStorage.setItem(this.key, JSON.stringify(this.items)); } catch (_) {}
      this.querySelector('[data-progress]').textContent = `${count} / ${this.required} Selected`;
      this.querySelector('[data-mobile-progress]').textContent = `${count} / ${this.required} Selected`;
      this.querySelector('[data-meter]').value = count;
      this.querySelector('[data-empty]').hidden = count > 0;
      this.querySelector('[data-help]').textContent = full ? 'Your bundle is ready.' : `Choose ${this.required - count} more.`;
      const list = this.querySelector('[data-list]'); list.replaceChildren();
      const groupedItems = new Map();
      this.items.forEach((item, index) => {
        const key = `${item.id}:${item.variant}`;
        if (groupedItems.has(key)) groupedItems.get(key).quantity += 1;
        else groupedItems.set(key, {item, index, quantity: 1});
      });
      groupedItems.forEach(({item, index, quantity}) => {
        const li = document.createElement('li');
        if (/^(https?:)?\/\//.test(item.image)) { const img = document.createElement('img'); img.src = item.image; img.alt = ''; li.append(img); }
        const info = document.createElement('div'); info.className = 'rb-item-info';
        const title = document.createElement('span'); title.textContent = item.title;
        const variant = document.createElement('small'); variant.textContent = item.variant === 'Default Title' ? `Quantity: ${quantity}` : `${item.variant} · Qty ${quantity}`;
        const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'rb-remove'; remove.dataset.remove = index; remove.textContent = quantity > 1 ? 'Remove one' : 'Remove'; remove.setAttribute('aria-label', `Remove one ${item.title}, ${item.variant}`); remove.disabled = this.busy;
        info.append(title, variant, remove); li.append(info); list.append(li);
      });
      this.querySelectorAll('[data-card]').forEach(card => {
        const select = card.querySelector('[data-variant]');
        card.querySelector('[data-pick]').disabled = this.busy || full || !select.value;
        select.disabled = this.busy;
        const ids = new Set([...select.options].map(o => o.value));
        const picked = this.items.filter(x => ids.has(x.id)).length;
        card.querySelector('[data-card-count]').textContent = picked ? `${picked} selected` : '';
      });
      const submit = this.querySelector('[data-submit]');
      submit.disabled = !this.dataset.parent || !full || this.busy || submit.dataset.unavailable === 'true';
      if (submit.dataset.unavailable !== 'true') submit.textContent = this.busy ? 'Adding…' : 'Add Bundle to Cart';
      const mobileAdd = this.querySelector('[data-mobile-add]');
      if (mobileAdd) {
        mobileAdd.disabled = submit.disabled;
        mobileAdd.textContent = this.busy ? 'Adding…' : submit.dataset.unavailable === 'true' ? 'Bundle unavailable' : 'Add to Cart';
      }
      const mobileMessage = this.querySelector('[data-mobile-message]');
      if (mobileMessage) mobileMessage.textContent = this.querySelector('[data-message]').textContent;
      const properties = this.querySelector('[data-properties]'); properties.replaceChildren();
      const add = (key, value) => { const input = document.createElement('input'); input.type = 'hidden'; input.name = `properties[${key}]`; input.value = value; properties.append(input); };
      add('Bundle', `Pick ${this.required}`);
      this.items.forEach((x, i) => add(`Item ${String(i + 1).padStart(2, '0')}`, `${x.title} / ${x.variant} / Qty: 1${x.sku ? ` / SKU: ${x.sku}` : ''}`));
      add('_bundle_variants', JSON.stringify(this.items.map(x => ({id:x.id,quantity:1}))));
      add('_bundle_collection', this.dataset.source);
      add('_runzie_bundle_items', JSON.stringify(this.items.map(x => ({id:x.id,title:x.title,variant:x.variant,sku:x.sku,image:x.image,quantity:1}))));
    }
    async page(href) {
      if (this.busy) return;
      const catalog = this.querySelector('[data-catalog]');
      this.pageAbort?.abort(); this.pageAbort = new AbortController();
      catalog.setAttribute('aria-busy','true');
      try {
        const url = new URL(href, location.href);
        if (url.origin !== location.origin) throw new Error('Invalid page.');
        url.searchParams.set('section_id', this.dataset.section);
        const response = await fetch(url, {signal:this.pageAbort.signal});
        if (!response.ok) throw new Error('Could not load products. Please try again.');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = doc.getElementById(this.id)?.querySelector('[data-catalog]');
        if (!next) throw new Error('Could not load products. Please try again.');
        catalog.replaceChildren(...next.childNodes); this.render();
        catalog.scrollIntoView({behavior:'smooth',block:'start'});
      } catch (error) { if (error.name !== 'AbortError') this.querySelector('[data-message]').textContent = error.message; }
      finally { catalog.removeAttribute('aria-busy'); }
    }
    async submit(e) {
      e.preventDefault();
      if (!this.dataset.parent || this.busy || this.items.length !== this.required || this.querySelector('[data-submit]').dataset.unavailable === 'true') return;
      this.busy = true; this.render();
      const message = this.querySelector('[data-message]'); message.textContent = '';
      const form = this.querySelector('[data-bundle-form]');
      const body = new FormData(form);
      const preparedProperties = {};
      for (const [key,value] of body) {
        const match = key.match(/^properties\[(.*)\]$/);
        if (match) preparedProperties[match[1]] = value;
      }
      document.dispatchEvent(new CustomEvent('runzie:bundle-prepared', {detail:{properties:preparedProperties}}));
      const sections = [];
      document.dispatchEvent(new CustomEvent('cart:grouped-sections', {bubbles:true,detail:{sections}}));
      if (sections.length) body.set('sections', [...new Set(sections)].slice(0,5).join(','));
      body.set('sections_url', location.pathname);
      let added = false;
      try {
        const response = await fetch(`${this.dataset.root}cart/add.js`, {method:'POST',headers:{Accept:'application/json'},body});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : 'Unable to add this bundle. Please try again.');
        added = true; this.items = []; this.render();
        message.textContent = 'Your bundle has been added to the cart.';
        this.querySelector('[data-view-cart]').hidden = false;
        // Use the existing theme events; never replace or instantiate a cart drawer.
        try {
          if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents) window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, {cart:result,productVariantId:form.elements.id.value});
          document.dispatchEvent(new CustomEvent('product-ajax:added', {detail:{product:result}}));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (_) { /* Cart remains available through its normal link. */ }
        if (this.dataset.after === 'cart') location.assign(this.dataset.cartUrl);
      } catch (error) {
        message.textContent = added ? 'Bundle added. Open your cart to review it.' : `${error.message} If your connection was interrupted, check your cart before trying again.`;
      } finally { this.busy = false; this.render(); }
    }
  });
}

if (!customElements.get('runzie-bundle-tabs')) {
  customElements.define('runzie-bundle-tabs', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.addEventListener('click', e => {
        const tab = e.target.closest('[data-activity-tab]');
        if (tab) this.select(tab.dataset.activityTab);
      }, options);
      this.addEventListener('keydown', e => {
        const tab = e.target.closest('[data-activity-tab]');
        if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
        const tabs = [...this.querySelectorAll('[data-activity-tab]')];
        let index = tabs.indexOf(tab);
        if (e.key === 'Home') index = 0;
        else if (e.key === 'End') index = tabs.length - 1;
        else index = (index + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        e.preventDefault(); this.select(tabs[index].dataset.activityTab); tabs[index].focus();
      }, options);
      this.addEventListener('shopify:block:select', e => {
        const panel = e.target.closest('[data-activity-panel]');
        if (panel) this.select(panel.dataset.activityPanel);
      }, options);
    }
    select(id) {
      this.querySelectorAll('[data-activity-tab]').forEach(tab => {
        const active = tab.dataset.activityTab === id;
        tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1;
      });
      this.querySelectorAll('[data-activity-panel]').forEach(panel => {
        const active = panel.dataset.activityPanel === id;
        if (!active) {
          const bundle = panel.querySelector('runzie-bundle');
          bundle?.classList.remove('is-open');
          const backdrop = bundle?.querySelector('.rb-backdrop'); if (backdrop) backdrop.hidden = true;
          bundle?.querySelector('[data-toggle]')?.setAttribute('aria-expanded','false');
        }
        panel.hidden = !active;
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
